import * as tslib_1 from "tslib";
import React from 'react';
import classNames from 'classnames';
import { AccessibilityListener, normalizeInitialState, Context, } from 'wix-rich-content-common';
import { convertToReact } from './utils/convertContentState';
import { getNormalizedContentBlocks } from '../../../../utils/editorNormilizeBlocks';
var RichContentViewer = /** @class */ (function (_super) {
    tslib_1.__extends(RichContentViewer, _super);
    function RichContentViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.initContext = function () {
            var _a = _this.props, theme = _a.theme, isMobile = _a.isMobile, anchorTarget = _a.anchorTarget, relValue = _a.relValue, config = _a.config, helpers = _a.helpers, locale = _a.locale;
            _this.contextualData = {
                theme: theme,
                isMobile: isMobile,
                anchorTarget: anchorTarget,
                relValue: relValue,
                config: config,
                helpers: helpers,
                locale: locale,
            };
        };
        _this.state = {
            prevInit: props.initialState,
            raw: RichContentViewer.getInitialState(props.initialState, props.anchorTarget, props.relValue),
        };
        _this.initContext();
        return _this;
    }
    RichContentViewer.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.prevInit !== nextProps.initialState) {
            return {
                raw: RichContentViewer.getInitialState(nextProps.initialState, nextProps.anchorTarget, nextProps.relValue),
            };
        }
        return null;
    };
    RichContentViewer.getInitialState = function (initialState, anchorTarget, relValue) {
        var normalized = initialState
            ? normalizeInitialState(initialState, {
                anchorTarget: anchorTarget,
                relValue: relValue,
            })
            : {};
        if (normalized && normalized.blocks) {
            normalized.blocks = getNormalizedContentBlocks(normalized.blocks);
        }
        return normalized;
    };
    RichContentViewer.prototype.render = function () {
        var _a, _b;
        var _c = this.props, textDirection = _c.textDirection, typeMappers = _c.typeMappers, decorators = _c.decorators, theme = _c.theme, isMobile = _c.isMobile;
        var wrapperClassName = classNames(theme.wrapper, (_a = {},
            _a[theme.desktop] = !isMobile,
            _a[theme.mobile] = isMobile,
            _a));
        var editorClassName = classNames(theme.editor, (_b = {},
            _b[theme.rtl] = textDirection === 'rtl',
            _b));
        var output = convertToReact(this.state.raw, theme, textDirection, typeMappers, this.contextualData, decorators);
        return (React.createElement("div", { className: wrapperClassName },
            React.createElement(Context.Provider, { value: this.contextualData },
                React.createElement("div", { className: editorClassName }, output),
                React.createElement(AccessibilityListener, null))));
    };
    return RichContentViewer;
}(React.Component));
export default RichContentViewer;
//# sourceMappingURL=ReactViewer.js.map